import api from './api';
import { User } from '../types';

interface LoginResponse {
  user: User;
  token: string;
}

interface BackendLoginResponse {
  user: User;
  accessToken: string;
}

export const authService = {
  login: async (email: string, password: string): Promise<LoginResponse> => {
    const response = await api.post<BackendLoginResponse>('/auth/login', { email, password });
    return {
      user: response.data.user,
      token: response.data.accessToken,
    };
  },

  register: async (name: string, email: string, password: string): Promise<LoginResponse> => {
    const response = await api.post<BackendLoginResponse>('/auth/register', { name, email, password });
    return {
      user: response.data.user,
      token: response.data.accessToken,
    };
  },

  getProfile: async (): Promise<User> => {
    const response = await api.get('/users/me');
    return response.data;
  },

  forgotPassword: async (email: string) => {
    const response = await api.post('/auth/forgot-password', { email });
    return response;
  },

  resetPassword: async (token: string, newPassword: string) => {
    const response = await api.post('/auth/reset-password', { token, newPassword });
    return response.data;
  },

  setup: async (name: string, email: string, password: string): Promise<LoginResponse> => {
    const response = await api.post<BackendLoginResponse>('/auth/setup', { name, email, password });
    return {
      user: response.data.user,
      token: response.data.accessToken,
    };
  },

  checkSetup: async (): Promise<{ needsSetup: boolean }> => {
    const response = await api.get('/auth/setup/check');
    return response.data;
  },
};
